import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import withPopupErrors from '../../../components/HOC/withPopupErrors/withPopupErrors';

import compare from '../../../lib/compare';
import usePagination from '../../../lib/hooks/usePagination';
import { useFilters } from '../../../components/common/Filters/Filters';
import { selectCities } from '../../../redux/reducers/CitiesReducer';
import { selectSchools } from '../../../redux/reducers/SchoolsReducer';
import { selectSchoolTypes } from '../../../redux/reducers/SchoolTypesReducer';

import ActionsBar from '../../../components/common/ActionsBar/ActionsBar';
import SchoolsFilters from '../../../components/admin/SchoolsList/Filters';
import CreateSchoolForm from '../../../components/admin/SchoolsList/CreationForm';
import SchoolsTable from '../../../components/admin/SchoolsList/Table';

import plusIcon from '../../../assets/add.svg';

interface Props {
  unauthorizedCallback: () => void;
  showError: (text: string) => void;
}

const SchoolsPage = ({ unauthorizedCallback, showError }: Props) => {
  const [showCreateWindow, setShowCreateWindow] = useState(false);
  const [filters, setFilter] = useFilters({ name: '', city: '', code: '' });
  const [sortData, setSortData] = useState({
    column: 'Название',
    descending: false,
  });

  const schools = useSelector(selectSchools);
  const cities = useSelector(selectCities);
  const schoolTypes = useSelector(selectSchoolTypes);

  console.log(schools);

  const filteredAndSortedSchools = Object.values(schools)
    .filter(
      (school) =>
        (console.log(school), 1) && 
        new RegExp(filters.name, 'i').test(school.name) &&
        new RegExp(filters.code, 'i').test(school.code) &&
        new RegExp(filters.city, 'i').test(cities[school.cityId]?.name ?? '') &&
        new RegExp(filters.type, 'i').test(schoolTypes[school.typeId]?.name ?? ''),
    )
    .sort((first, second) => {
      switch (sortData.column) {
        case 'Название':
          return compare(first.name, second.name);
        case 'Код':
          return compare(first.code, second.code);
        default:
          return compare(
            cities[first.cityId]?.name ?? '',
            cities[second.cityId]?.name ?? '',
          );
      }
    });

  if (sortData.descending) filteredAndSortedSchools.reverse();

  const { paginator, page } = usePagination(
    Math.ceil(filteredAndSortedSchools.length / 10),
  );

  const schoolsForRender = filteredAndSortedSchools.slice(
    (page - 1) * 10,
    page * 10,
  );

  return (
    <div style={{ display: 'flex', gap: '5rem' }}>
      <div style={{ width: '45vw', minWidth: '20rem' }}>
        <ActionsBar
          actionButtons={[
            {
              src: plusIcon,
              alt: 'Добавить школу',
              placement: 'right',
              onClick: () => setShowCreateWindow(true),
            },
          ]}
        />

        <SchoolsTable
          schools={schoolsForRender}
          cities={cities}
          schoolTypes={schoolTypes}
          unauthorizedCallback={unauthorizedCallback}
          showError={showError}
          sortData={sortData}
          setSortData={setSortData}
        />

        {paginator}
      </div>

      <SchoolsFilters filters={filters} setFilter={setFilter} />

      {showCreateWindow && (
        <CreateSchoolForm onClose={() => setShowCreateWindow(false)} />
      )}
    </div>
  );
};

export default withPopupErrors<Props>(SchoolsPage);
